import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useEndVideoCallMutation as useEndVideoCallMutationType } from "@/modules/video-call/services/__generated__/useEndVideoCallMutation.graphql"

const endVideoCallMutation = graphql`
  mutation useEndVideoCallMutation($input: EndVideoCallInput!) {
    endVideoCall(input: $input) {
      endVideoCallOutput {
        isSuccessful
        roomSid
      }
      errors {
        ... on CannotFindAvailableVideoCallRoom {
          message
          roomSid
        }
      }
    }
  }
`

const useEndVideoCallMutation = () => {
  const [commit] = useMutation<useEndVideoCallMutationType>(endVideoCallMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useEndVideoCallMutationType>) => {
      commit(config)
    },
    [commit],
  )
  return commitHandler
}

export { useEndVideoCallMutation }
